import { render, staticRenderFns } from "./formConfiguration.vue?vue&type=template&id=2f94b3c6&scoped=true&"
import script from "./formConfiguration.vue?vue&type=script&lang=js&"
export * from "./formConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f94b3c6",
  null
  
)

export default component.exports